import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <title>{props.title || 'Download'}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          fill="#999999"
          d="M7.11007775,2.12374214 L8.88938839,2.12374214 L8.88938839,7.67667237 L10.431426,6.22573283 L11.6768722,7.3976026 L7.99973307,10.8586259 L4.3225939,7.3976026 L5.56804017,6.22573283 L7.11007775,7.67667237 L7.11007775,2.12374214 Z M15,12.4493235 L15,14.1237421 L1,14.1237421 L1,12.4493235 L15,12.4493235 Z"
        />
      </g>
    </Icon>
  )
}
